<template>
    <div class="fixed z-50 flex items-center justify-between w-full px-6 py-4 bg-white">
        <!-- <div>
            <inertia-link href="/dashboard">
                <img src="/img/osm-logo.svg" alt="OSM" class="w-20">
            </inertia-link>
        </div> -->
        <div class="flex items-center">
            <inertia-link href="/user/profile">
                <div class="font-bold text-gray-700">
                    {{ user.name }}
                </div>
            </inertia-link>
            <!-- <div class="ml-2">
                <SelectLocaleVue></SelectLocaleVue>
            </div> -->
        </div>
    </div>
</template>
<script>
    // import SelectLocaleVue from '../Components/SelectLocale.vue';
    export default {
        props: ['user'],
        // components: {
        //     SelectLocaleVue
        // },
    }
</script>